import { render, staticRenderFns } from "./ProjectsMandatorySwitch.vue?vue&type=template&id=25173354&scoped=true&"
import script from "./ProjectsMandatorySwitch.vue?vue&type=script&lang=js&"
export * from "./ProjectsMandatorySwitch.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsMandatorySwitch.vue?vue&type=style&index=0&id=25173354&lang=scss&scoped=true&"
import style1 from "./ProjectsMandatorySwitch.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25173354",
  null
  
)

export default component.exports